const MAP_CONFIDENCE_INFO = [
  {
    text: 'Transaction matched to modem, asset, and sublocation using modem_history and assetHistory for the transaction date.',
  },
  {
    val: '-4',
    text: 'There is an assetHistory row for the asset where the transaction date falls between inEffectFrom and inEffectTo, but that row has no sublocation.',
  },
  {
    val: '-5',
    text: 'Similar to -4, but we have an old sublocation for the asset; that old sublocation name is shown in the sublocation column.',
  },
  {
    val: '-3',
    text: 'There is no assetHistory row for the asset that corresponds to the modem at the transaction date, but there is a matching row in modem_history.',
  },
  {
    val: '-2',
    text: 'There is no modem_history row, but we do have matching rows in the current (non-historical) modem and asset tables.',
  },
  {
    val: '-1',
    text: ' Similar to -2, but we only have data in the current modem table and are missing the corresponding asset in the current asset table.',
  },
];

export { MAP_CONFIDENCE_INFO };
